import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, text, dark = false, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p
        className={`text-xs font-semibold uppercase tracking-[0.25em] ${
          dark ? "text-lime-400" : "text-lime-600"
        }`}
      >
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-4 font-serif text-3xl tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.15] ${
          dark ? "text-ivory" : "text-ink"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-ivory/70" : "text-moss"}`}>
          {text}
        </p>
      </Reveal>
    )}
  </div>
);
